import * as bootstrap from 'bootstrap';
import DataTable from 'datatables.net-bs5';
import DataTableCS from 'datatables.net-plugins/i18n/cs';

const PREVIOUS_ROW_CLASS = 'siblingShowed';
const CHILD_ROW_CLASS = 'dt-row-open';

function isDataTableInsertedChildRow(rowElement) {
    if (!(rowElement instanceof HTMLTableRowElement)) {
        return false;
    }

    if (rowElement.classList.contains('child')) {
        return true;
    }

    if (rowElement.cells.length !== 1 || !rowElement.hasAttribute('data-dt-row')) {
        return false;
    }

    const previous = rowElement.previousElementSibling;
    if (!(previous instanceof HTMLTableRowElement)) {
        return false;
    }

    return previous.classList.contains('dt-hasChild') || previous.classList.contains('shown');
}

function findPreviousDataRow(rowElement) {
    let previous = rowElement.previousElementSibling;

    while (previous) {
        if (previous instanceof HTMLTableRowElement && !previous.classList.contains('child')) {
            return previous;
        }

        previous = previous.previousElementSibling;
    }

    return null;
}

function syncSiblingShowedForTable(tableElement) {
    if (!(tableElement instanceof HTMLTableElement)) {
        return;
    }

    const tbody = tableElement.tBodies && tableElement.tBodies[0];
    if (!tbody) {
        return;
    }

    const rows = Array.prototype.filter.call(
        tbody.children,
        (node) => node instanceof HTMLTableRowElement
    );

    rows.forEach((row) => {
        row.classList.remove(PREVIOUS_ROW_CLASS);

        if (isDataTableInsertedChildRow(row)) {
            row.classList.add(CHILD_ROW_CLASS);
        } else {
            row.classList.remove(CHILD_ROW_CLASS);
        }
    });

    rows.forEach((row) => {
        if (!row.classList.contains('dt-hasChild') || !row.classList.contains('shown')) {
            return;
        }

        const previousDataRow = findPreviousDataRow(row);
        if (previousDataRow) {
            previousDataRow.classList.add(PREVIOUS_ROW_CLASS);
        }
    });
}

function syncSiblingShowed() {
    document.querySelectorAll('table').forEach(syncSiblingShowedForTable);
}

function initSiblingShowedObserver() {
    if (typeof window === 'undefined' || window.__sppkDataTableSiblingObserver) {
        return;
    }

    let isSyncQueued = false;
    const queueSync = () => {
        if (isSyncQueued) {
            return;
        }

        isSyncQueued = true;
        const run = () => {
            isSyncQueued = false;
            syncSiblingShowed();
        };

        if (typeof window.requestAnimationFrame === 'function') {
            window.requestAnimationFrame(run);
        } else {
            window.setTimeout(run, 0);
        }
    };

    const observe = () => {
        if (!document.body || window.__sppkDataTableSiblingObserver) {
            return;
        }

        queueSync();

        const observer = new MutationObserver((mutations) => {
            const shouldSync = mutations.some((mutation) => {
                if (mutation.type === 'childList') {
                    return true;
                }

                return mutation.type === 'attributes'
                    && mutation.target instanceof HTMLTableRowElement;
            });

            if (shouldSync) {
                queueSync();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });

        window.__sppkDataTableSiblingObserver = observer;
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', observe, { once: true });
        return;
    }

    observe();
}

// if (typeof DataTable.use === 'function') {
//     DataTable.use(bootstrap);
// }

if (DataTable.defaults) {

    const optionValue = Array.isArray(window.sppkConfig?.pagination?.tables)
        ? window.sppkConfig.pagination.tables.map((value) => Number(value)).filter((value) => value > 0)
        : [10, 25, 50, 100];

    DataTableCS.lengthMenu = 'Zobrazit _MENU_';
    DataTable.defaults.language = DataTableCS;
    DataTable.defaults.stateSave = true;
    DataTable.defaults.pagingType = 'simple_numbers';
    DataTable.defaults.lengthMenu = optionValue;
    DataTable.defaults.pageLength = optionValue[0] ?? 10;
    DataTable.defaults.layout = {
        topStart: null,
        topEnd: 'search',
        // bottomStart: 'info',
        bottomStart: 'pageLength',
        bottomEnd: 'paging',
    };
}

if (typeof window !== 'undefined') {
    window.DataTable = DataTable;
    initSiblingShowedObserver();
}

export default DataTable;
